

export default {
    totalRecords: 0,
    qurbanList: []
}
